export default __webpack_public_path__ + "static/media/air_mattress.a46243e9.svg";